/*
  Блок штрихкодов на задней обложке (表4) — то же наложение, что делает печать
  (PrintCoverSubtask): белая плашка сверху страницы и SVG с двумя EAN13
  (ISBN и JAN), ценой и издательством. Геометрия и разметка повторяют печатную,
  чтобы в редакторе была видна реальная занятая зона.

  Когда данных ещё нет (ISBN/JAN/цена не заполнены), в редакторе показывается
  пунктирная зона-заглушка — печать в этом случае штрихкоды не рисует.
*/

const BAND_HEIGHT_MM = 58 // 55мм зоны + 3мм вылета сверху, как в печати

function formatIsbnForBarcode (isbn) {
  return `ISBN${isbn.slice(0, 3)}-${isbn.slice(3, 4)}-${isbn.slice(4, 7)}-${isbn.slice(7, 12)}-${isbn.slice(12, 13)}`
}

class CoverBarcodes {
  isbn
  jan
  retailPrice

  constructor (data = {}) {
    this.isbn = data.isbn || ''
    this.jan = data.jan || ''
    this.retailPrice = data.retailPrice || 0
  }

  get isComplete () {
    return /^97[89]\d{10}$/.test(this.isbn) && /^\d{12,13}$/.test(this.jan) && Number(this.retailPrice) > 0
  }

  renderLayout () {
    if (!this.isComplete) {
      return `
        <div class="cover-barcodes cover-barcodes_placeholder">
          <span>ISBN・JANバーコード（自動配置）</span>
        </div>
      `
    }

    // Разметка SVG — копия печатной (PrintCoverSubtask)
    return `
      <div class="cover-barcodes">
        <svg class="cover-barcodes__info" viewBox="0 0 1000 580" version="1.1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve">
          <g>
            <text x="150" y="160" font-family="'Noto Sans JP', serif" font-size="28" font-weight="400">${formatIsbnForBarcode(this.isbn)}</text>
            <text x="150" y="195" font-family="'Noto Sans JP', serif" font-size="28" font-weight="400">C${this.jan.slice(3, 7)} ¥${this.retailPrice}E</text>
          </g>

          <g>
            <clipPath id="cover-barcode-clip-1">
              <rect x="560" y="130" width="320" height="110" />
            </clipPath>
            <text x="525" y="300" font-family="'Libre Barcode EAN13 Text', serif" font-size="285" clip-path="url(#cover-barcode-clip-1)">${this.isbn}</text>
            <text x="560" y="280" textLength="320" font-family="'B612 Mono', monospace" font-size="35">${this.isbn}</text>
          </g>

          <g>
            <text x="150" y="370" font-family="'Noto Sans JP', serif" font-size="28" font-weight="400">定価（本体${this.retailPrice}円＋税）</text>
            <text x="150" y="405" font-family="'Noto Sans JP', serif" font-size="28" font-weight="400">Booko出版</text>
          </g>

          <g>
            <clipPath id="cover-barcode-clip-2">
              <rect x="560" y="340" width="320" height="110" />
            </clipPath>
            <text x="525" y="490" font-family="'Libre Barcode EAN13 Text', serif" font-size="285" clip-path="url(#cover-barcode-clip-2)">${this.jan}</text>
            <text x="560" y="490" textLength="320" font-family="'B612 Mono', monospace" font-size="35">${this.jan}</text>
          </g>
        </svg>
      </div>
    `
  }

  /* pageWidthMm/offsetMm — положение задней страницы внутри листа обложки. */
  renderStyle (prefix, pageWidthMm, offsetMm = 0) {
    return `
      #${prefix} .cover-barcodes {
        position: absolute;
        top: 0;
        left: ${offsetMm}mm;
        width: ${pageWidthMm}mm;
        height: ${BAND_HEIGHT_MM}mm;
        background-color: white;
        pointer-events: none;
        z-index: 10;
      }
      #${prefix} .cover-barcodes__info {
        position: absolute;
        top: 0;
        right: 0;
        width: auto;
        height: 100%;
      }
      #${prefix} .cover-barcodes_placeholder {
        background-color: rgba(255, 255, 255, 0.75);
        border-bottom: 1px dashed rgba(0, 0, 0, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      #${prefix} .cover-barcodes_placeholder span {
        font-size: 5mm;
        color: rgba(0, 0, 0, 0.4);
        font-family: 'Noto Sans JP', sans-serif;
      }
    `
  }
}

export { CoverBarcodes, BAND_HEIGHT_MM }
